import axiosInstance from './axios';
import { handleError } from './utils';
const syncService = {
  syncData: async () => {
    try {
      const response = await axiosInstance.post('/sync');
      if (response.status !== 200) {
        throw new Error('Failed to sync data');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      handleError(error);
    }
  },
};

export default syncService;
